export const actionTypes = {
  SET_ACTION: 'SET_ACTION'
} as const

export function setAction(action: string) {
  return { type: actionTypes.SET_ACTION, action }
}

export type Action = ReturnType<typeof setAction>
